<template>
  <CommonDrop ref="drop" v-model="currentValue" label-name="accountName" url="/settings/account/list" :autoDefault="false" size="mini"></CommonDrop>
</template>
<script>
import CommonDrop from '@/components/CommonDrop'

export default {
  components: { CommonDrop },
  name: 'factory',
  props: {
    value: {
      type: String | Number,
      default: null
    }
  },
  computed: {
    currentValue: {
      get () {
        if (this.value === null || this.value === undefined) {
          return ''
        }
        return String(this.value)
      },
      set (newVal) {
        this.$emit('input', newVal)
        this.$emit('change', this.$refs.drop.dataList.find(item => item.id === newVal))
      },
    },
  },
  methods: {}
}
</script>
